import "./App.css";
import LoginForm from "./Components/LoginForm";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingProvider } from "./Utils/LoadingContext";
import Loader from "./Components/Shared/Loader";

import DashBoard from "./Components/MemberRegister/Main/DashBoard";
import Payment from "./Components/PaymentRegister/Payment";
import Nav from "./Components/Shared/Nav";
import DetailsTab from "./Components/MemberRegister/Details/DetailsTab";
import DairySales from "./Components/DairySales";
import DairyExpense from "./Components/DairyExpense";
import DailyRegister from "./Components/DailyRegister";
import DairyRegister from "./Components/DairyRegister";
import AddMember from "./Components/MemberRegister/AddMember";
import Logout from "./Components/Shared/Logout";
import ChangePassword from "./Components/ChangePassword";
import RegisterDairy from "./Components/RegisterDairy";
import Account from "./Components/MemberRegister/Details/Account";
import AnimalFood from "./Components/MemberRegister/Details/AnimalFood";
import PaymentRegister from "./Components/PaymentRegister/PaymentDetail";
import BulkUpload from "./Components/BulkUpload/BulkUpload";
import Analytics from "./Components/Analytics/Analytics";
import Bonus from "./Components/Bonus/Bonus";
import CustomRateChart from "./Components/CustomRateChart";
import ProtectedRoute from "./Utils/ProtectedRoute";

function App() {
  return (
    <LoadingProvider>
      <div className="App">
        <Loader />
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
          draggable
          theme="colored"
          limit={3}
          toastStyle={{ fontSize: "14px" }}
        />
        <Router>
          <Layout />
        </Router>
      </div>
    </LoadingProvider>
  );
}

function Layout() {
  const location = useLocation();
  const hideNavbarOn = ["/", "/RegisterDairy"]; // pages where Nav should NOT appear

  return (
    <>
      {!hideNavbarOn.includes(location.pathname) && <Nav />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LoginForm />} />
        <Route path="/RegisterDairy" element={<RegisterDairy />} />

        {/* ✅ Protect ALL other routes in one block */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                <Route path="dashboard" element={<DashBoard />} />
                <Route path="payment" element={<Payment />} />
                <Route path="DetailsTab" element={<DetailsTab />} />
                <Route path="DairySales" element={<DairySales />} />
                <Route path="DairyExpense" element={<DairyExpense />} />
                <Route path="DailyRegister" element={<DailyRegister />} />
                <Route path="DairyRegister" element={<DairyRegister />} />
                <Route path="AddMember" element={<AddMember />} />
                <Route path="ChangePassword" element={<ChangePassword />} />
                <Route path="Logout" element={<Logout />} />
                <Route path="Account" element={<Account />} />
                <Route path="AnimalFood" element={<AnimalFood />} />
                <Route path="PaymentRegister" element={<PaymentRegister />} />
                <Route path="bulk-upload" element={<BulkUpload />} />
                <Route path="Analytics" element={<Analytics />} />
                <Route path="Bonus" element={<Bonus />} />
                <Route path="CustomRateChart" element={<CustomRateChart />} />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}


export default App;
